module.exports = __webpack_public_path__ + "img/voucher.75daf354.png";